import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi, withXhr } from '@angular/common/http';
import { ApplicationConfig, importProvidersFrom, inject, provideAppInitializer, provideZoneChangeDetection } from '@angular/core';
import { BrowserAnimationsModule, provideAnimations } from '@angular/platform-browser/animations';
import { provideRouter, withComponentInputBinding, withInMemoryScrolling } from '@angular/router';
import { AppConfigService, ErrorInterceptor } from '@app-core';
import { NgxGoogleAnalyticsModule, NgxGoogleAnalyticsRouterModule } from 'ngx-google-analytics';
import { NgxMaskConfig, provideEnvironmentNgxMask } from 'ngx-mask';
import { NgxSpinnerModule } from 'ngx-spinner';
import { ROUTES } from './app.routes';

const maskConfig: Partial<NgxMaskConfig> = {
    validation: false,
};

export function initializeApplication(appConfigService: AppConfigService): () => Promise<void> {
    return () => appConfigService.loadLookupData();
}

export const appConfig: ApplicationConfig = {
    providers: [
        provideZoneChangeDetection({ eventCoalescing: true }),
        provideRouter(ROUTES, withComponentInputBinding(), withInMemoryScrolling({ scrollPositionRestoration: 'top' })),
        provideHttpClient(withXhr(), withInterceptorsFromDi()),
        {
            provide: HTTP_INTERCEPTORS,
            useClass: ErrorInterceptor,
            multi: true,
        },
        importProvidersFrom(BrowserAnimationsModule),
        importProvidersFrom(NgxSpinnerModule.forRoot({ type: 'ball-beat' })),
        provideEnvironmentNgxMask(),
        provideAnimations(),
        importProvidersFrom(NgxGoogleAnalyticsModule.forRoot('G-D8KFJ38FGK')),
        importProvidersFrom(NgxGoogleAnalyticsRouterModule),
        provideAppInitializer(() => {
            const initializerFn = initializeApplication(inject(AppConfigService));
            return initializerFn();
        }),
    ],
};
